import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { availableLanguages, changeLanguage, getCurrentLanguage } from '../i18n';
import MobileBottomSheet from './MobileBottomSheet';

function LanguageSwitcher({ onClose }) {
  const { t } = useTranslation();
  const [currentLang, setCurrentLang] = useState(getCurrentLanguage());
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setCurrentLang(langCode);
    if (onClose) {
      onClose();
    }
  };

  const content = (
    <>
      {/* Header */}
      <div className="flex items-center justify-between py-4 border-b border-white/10">
        <h2 className="text-lg font-bold text-white">{t('nav.language')}</h2>
        <button
          onClick={onClose}
          className="w-9 h-9 rounded-full hover:bg-white/10 flex items-center justify-center transition-colors"
        >
          <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Language List */}
      <div className="py-2">
        {availableLanguages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            className={`w-full flex items-center gap-4 px-2 py-3 rounded-lg transition-colors ${
              currentLang === lang.code
                ? 'bg-green-500/20 text-green-500'
                : 'hover:bg-white/10 text-white'
            }`}
          >
            <span className="text-2xl">{lang.flag}</span>
            <span className="flex-1 text-left font-medium">{lang.name}</span>
            {currentLang === lang.code && (
              <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            )}
          </button>
        ))}
      </div>

      {/* Footer */}
      <div className="py-4 border-t border-white/10">
        <p className="text-sm text-white/60 text-center">
          {t('profile.language')}: {availableLanguages.find(l => l.code === currentLang)?.name}
        </p>
      </div>
    </>
  );

  if (isMobile) {
    return (
      <MobileBottomSheet isOpen={true} onClose={onClose}>
        {content}
      </MobileBottomSheet>
    );
  }

  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 modal-text">
      <div className="bg-[#282828] rounded-xl max-w-md w-full max-h-[80vh] overflow-hidden shadow-2xl p-4">
        {content}
      </div>
    </div>
  );
}

export default LanguageSwitcher;
